import { memo } from "react";
import { useTranslation } from "react-i18next";
import { List, ListSubheader } from "@mui/material";
// cmps
import DisconnectedDevice from "./DisconnectedDevice";
// hooks
import useSorter from "../../../hooks/useSorter";
// types
import type { DeviceObjs } from "../../../types/device";
import type { CustomForceGraphNode } from "../../../types/misc";

type Props = Readonly<{
	zigbeeDevices: DeviceObjs;
	nodes: ReadonlyArray<CustomForceGraphNode>;
}>;

const DisconnectedDevices = ({ zigbeeDevices, nodes }: Props) => {
	const { t } = useTranslation();

	const sortAlphabetically = useSorter();

	if (zigbeeDevices.length === 0) {
		return null;
	}
	const disconnectedDevices = zigbeeDevices.filter((device) => (
		nodes.every((node) => (node.id !== device.id))
	)).toSorted((deviceA, deviceB) => (sortAlphabetically(deviceA.name, deviceB.name)));

	return (
		<List
			className="disconnected-devices-list"
			subheader={<ListSubheader disableSticky={true}>{t("gateway.disconnectedDevices")}</ListSubheader>}
			style={{ maxHeight: "700px", overflow: "auto", border: "1px solid #a9a9a9" }}
		>
			{disconnectedDevices.map((device, index) => (
				<DisconnectedDevice
					key={device.id}
					deviceId={device.id}
					deviceName={device.name}
					divider={index > 0}
				/>
			))}
		</List>
	);
};

export default memo(DisconnectedDevices);
